export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/toubiaobaohan-a500c3e059e5fee0ebb1641f67baa7e4.jpeg";